// @owners { team: patients }
import { COLORS } from '@alto/design-library-tokens';
import { Body, Column, MdPadding, Row, XxxxlSpacing } from '@alto/design-system';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
// eslint-disable-next-line import/no-deprecated
import { fetchUserSubscriptions } from '~shared/actions/subscriptions';
import logoAlto from '~shared/assets/images/altoLogo@2x.png';
import { getErrorMessage } from '~shared/helpers/helper';
import { useDispatchShared, useSelectorShared } from '~shared/store';
import { PrefsConfirmationPage } from './PrefsConfirmationPage';
import { SubscriptionOptions } from './SubscriptionOptions';

const LogoContainer = styled.a`
  width: 106px;
`;

const AltoLogo = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

type RouteParams = {
  readonly uuid: string;
};

export const SubscriptionsPage = () => {
  const { uuid = '' } = useParams<RouteParams>();
  const dispatch = useDispatchShared();
  const error = useSelectorShared(
    (state) => state.ui.errors.fetchUserSubscriptionsError || state.ui.errors.updateUserSubscriptionsError,
  );
  const errorMessage = getErrorMessage(error);
  const [isUpdated, setIsUpdated] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line import/no-deprecated
    dispatch(fetchUserSubscriptions(uuid));
  }, [dispatch, uuid]);

  return (
    <Column
      flexShrink={0}
      flexGrow={1}
      centerHorizontally
      backgroundColor={COLORS.BACKGROUND_COLORS.WHITE}
    >
      <Row center>
        <MdPadding>
          <LogoContainer
            href="https://alto.com"
            aria-label="Alto Logo"
          >
            <AltoLogo src={logoAlto} />
          </LogoContainer>
        </MdPadding>
      </Row>
      <XxxxlSpacing />
      {errorMessage ? <Body center>{errorMessage}</Body> : null}
      {isUpdated ? (
        <PrefsConfirmationPage />
      ) : (
        <SubscriptionOptions
          setIsUpdated={setIsUpdated}
          uuid={uuid}
        />
      )}
    </Column>
  );
};
